import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Alert, App, Button, Empty, Space, Table, Tag, Tooltip, Typography } from 'antd';
import { FileExcelOutlined, ReloadOutlined, ToolOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { enhanceColumns, toplamGenislik } from '../ortak/tableHelpers';
import { LokasyonLinki, excelIndir, hata, tarih } from './ortak';

/**
 * S5 İnşaata Geçiş (26.10.2026) — /satis-sureci/insaat-gecis. YALNIZ LİSTE (kullanıcı kararı): görev ya da bildirim
 * açılmaz; inşaat talebi /insaat-enerji ekranından operasyon tarafından açılır.
 * Satır = Aday / Kurulumu tamamlanmamış aktif lokasyon + süresi devam eden imzalı YS + aktif banka sözleşmesi,
 * açık (active = 1) inşaat talebi yok.
 */
const { Text } = Typography;

export default function InsaatGecis({ api }) {
  const { message } = App.useApp();
  const [veri, setVeri] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const yukle = useCallback(() => {
    setYukleniyor(true);
    api.get('/insaat-gecis').then(setVeri).catch((e) => message.error(hata(e))).finally(() => setYukleniyor(false));
  }, [api, message]);
  useEffect(() => { yukle(); }, [yukle]);

  const kolonlar = useMemo(() => enhanceColumns([
    { title: 'Lokasyon', dataIndex: 'lokasyon_adi', width: 280, render: (v, r) => <LokasyonLinki id={r.lokasyon} ad={v} /> },
    { title: 'Durum', dataIndex: 'durum_adi', width: 170 },
    { title: 'Kategori', dataIndex: 'kategori_adi', width: 160 },
    { title: 'Sorumlu', dataIndex: 'sorumlu_adi', width: 160 },
    { title: 'YS giriş tarihi', dataIndex: 'ys_tarih', width: 115, render: tarih },
    { title: 'İlk banka sözleşmesi', dataIndex: 'ilk_banka', width: 140, render: tarih },
    { title: 'Banka söz.', dataIndex: 'banka_adet', width: 95, align: 'right' },
    { title: 'Bekleme', dataIndex: 'bekleme_gun', width: 110, align: 'right', render: (v) => (v === null || v === undefined ? '' : v < 0
      ? <Tooltip title="Banka sözleşmesi ileri tarihli"><Tag>{-v} gün sonra</Tag></Tooltip>
      : <Tag color={v > 30 ? 'error' : v > 14 ? 'warning' : 'default'}>{v} gün</Tag>) },
    { title: '', key: 'git', width: 120, render: () => <Link to="/insaat-enerji"><Button size="small" icon={<ToolOutlined />}>İnşaat & Enerji</Button></Link> },
  ]), []);
  const o = veri?.ozet;

  return (
    <div>
      <Alert type="info" showIcon style={{ marginBottom: 12 }} message="İnşaat'a geçiş operasyon sorumluluğundadır."
        description="Bu liste yalnız bilgi amaçlıdır; görev ya da bildirim açmaz. İnşaat talebi İnşaat & Enerji ekranından açılır; talep açılınca lokasyon bu listeden düşer." />
      <Space wrap style={{ marginBottom: 8 }}>
        <Button icon={<ReloadOutlined />} onClick={yukle} loading={yukleniyor}>Yenile</Button>
        <Button icon={<FileExcelOutlined />} onClick={() => excelIndir(api, { bolum: 'insaat' }, `satis-insaat-gecis-${dayjs().format('YYYYMMDD')}.xlsx`)
          .catch((e) => message.error(hata(e)))}>Excel</Button>
        {o && <>
          <Tag>{o.toplam} lokasyon</Tag>
          <Tag>{o.aday} Aday</Tag>
          <Tag>{o.tamamlanmamis} Kurulumu tamamlanmamış</Tag>
          <Tag color="error">{o.otuz_gun} lokasyon 30 günden uzun bekliyor</Tag>
        </>}
      </Space>
      <Table rowKey="lokasyon" size="small" loading={yukleniyor} columns={kolonlar} dataSource={veri?.satirlar || []}
        scroll={{ x: toplamGenislik(kolonlar) }} pagination={{ pageSize: 50, showSizeChanger: true }}
        locale={{ emptyText: <Empty description="İnşaata geçiş bekleyen lokasyon yok" /> }} />
      <Text type="secondary" style={{ fontSize: 12 }}>
        Bekleme = bugün − (YS sözleşmesinin sisteme girişi ile ilk banka sözleşmesi başlangıcının sonrakisi).
      </Text>
    </div>
  );
}
